import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { sessionDetailDtoSchema } from '../schemas/sessionSchemas';
import { sessionKeys } from './sessionKeys';

export function useSession(sessionId: string | undefined) {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: sessionKeys.detail(sessionId ?? ''),
    queryFn: async ({ signal }) => {
      const raw = await apiClient
        .get(`api/v1/t/${tenantId}/sessions/${sessionId}`, { signal })
        .json();
      return sessionDetailDtoSchema.parse(raw);
    },
    enabled: !!tenantId && !!sessionId,
  });
}
